import { z } from 'zod';

import { tryParseJSON } from '@/utils/try-parse-json';

import { OpenAIToolCallsKwargsSchema } from '../Message.utils';
import { ToolCallsList } from './ToolCallsList';

export function MessageKwargsOpenAITools(props: {
  toolKwargs: z.infer<typeof OpenAIToolCallsKwargsSchema>;
  onEdit?: (value: z.infer<typeof OpenAIToolCallsKwargsSchema>) => void;
}) {
  const items = props.toolKwargs.tool_calls.map((tc) => ({
    name: tc.function.name,
    id: tc.id,
    args: tryParseJSON(tc.function.arguments, true) as Record<string, unknown>,
  }));

  return (
    <ToolCallsList
      items={items}
      editable={!!props.onEdit}
      onChangeName={(index, name) => {
        if (!props.onEdit) return;
        const newToolCalls = props.toolKwargs.tool_calls.map((tc, i) =>
          i === index
            ? {
                ...tc,
                function: {
                  ...tc.function,
                  name,
                },
              }
            : tc
        );
        props.onEdit({ ...props.toolKwargs, tool_calls: newToolCalls });
      }}
      onChangeId={(index, id) => {
        if (!props.onEdit) return;
        const newToolCalls = props.toolKwargs.tool_calls.map((tc, i) =>
          i === index
            ? {
                ...tc,
                id,
              }
            : tc
        );
        props.onEdit({ ...props.toolKwargs, tool_calls: newToolCalls });
      }}
      onChangeArgs={(index, value) => {
        if (!props.onEdit) return;
        const newToolCalls = props.toolKwargs.tool_calls.map((tc, i) =>
          i === index
            ? {
                ...tc,
                function: {
                  ...tc.function,
                  arguments: JSON.stringify(value),
                },
              }
            : tc
        );
        props.onEdit({ ...props.toolKwargs, tool_calls: newToolCalls });
      }}
      onDelete={(index) => {
        if (!props.onEdit) return;
        props.onEdit({
          ...props.toolKwargs,
          tool_calls: props.toolKwargs.tool_calls.filter(
            (_, idx) => idx !== index
          ),
        });
      }}
    />
  );
}
